import { combineReducers } from '@reduxjs/toolkit';

import { favoriteSlice } from './favoriteSlice';

export const userSettingsReducer = combineReducers({
  favoritesObjectTypes: favoriteSlice.reducer,
});
